import Vue from 'vue';
import VueRouter from 'vue-router';
import routes from './routes';
import store from '@/store';

Vue.use(VueRouter);

function getScrollableElement () {
  return document.getElementById('app');
}
const scrollPositions = {};

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,

  scrollBehavior (to, from, savedPosition) {
    if (scrollPositions[to.name] && savedPosition) {
      getScrollableElement().scrollTo(scrollPositions[to.name].x, scrollPositions[to.name].y);
    } else {
      getScrollableElement().scrollTo(0, 0);
    }
  }

});

router.beforeEach((to, from, next) => {
  let element = getScrollableElement();
  if (element !== null) {
    scrollPositions[from.name] = { x: element.scrollLeft, y: element.scrollTop };
  }

  next();
});

router.beforeEach((to, from, next) => {
  store.dispatch('navigation/start');

  next();
});

router.afterEach((to, from) => {
  store.dispatch('navigation/end');
  Vue.nextTick(() => {
    let title = null;
    try {
      title = to.matched.map(r => r.meta.title).filter(i => !!i);
    } catch (err) {
      // nothing
    }

    title = Array.isArray(title) ? title.join(' > ') : title;

    document.title = 'Agrial - Commande Aliments' + (title ? ' - ' + title : '');
  });
});

router.onError(() => {
  store.dispatch('navigation/end');

  router.push({ name: 'login', params: { errorLoadingUser: true } });
});

export default router;
